export default function NotFound() {
  return (
    <main className="kn-page flex flex-col justify-center items-center h-screen text-center px-4">
      <h1 className="text-7xl font-bold tracking-[-0.02em] leading-[1.08] text-knapp-accent mb-4">
        404
      </h1>
      <p className="kn-lead mb-6">Oops! Diese Seite existiert nicht.</p>
      <a href="/" className="kn-btn-primary">
        Zurück zur Startseite
      </a>
    </main>
  );
}
